/* src/app/views/template/components/templates/digital/digital-spotlight-templates/digital-spotlight-templates.component.scss */
/*# sourceMappingURL=digital-spotlight-templates.component.css.map */
